export const getMessageFromActions = (response) => {
    const { data } = response?.response || response || {};

    return data?.actions?.PlayerActionShowMessage?.[0]?.message;
};

export const getTemplateIdFromActions = (response) => {
    const { data } = response?.response || response || {};

    return data?.actions?.PlayerActionShowMessage?.[0]?.templateId;
};

export const getUserError = (error) => {
    const { errorCode, userErrors, errorMessage, playerMessage } = error?.data || error?.response?.data || {}; // TotalCasino changes
    const userError = userErrors?.[0]?.message
        || userErrors?.UserError?.[0]?.message
        || errorMessage // TotalCasino changes
        || playerMessage; // TotalCasino changes

    return { userError, errorCode };
};
